import React, { useEffect, useRef, useState } from 'react';
import './Mission.css';

const MissionVision = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="mv-section" ref={sectionRef}>
      {/* Decorative background orbs */}
      <div className="mv-orb mv-orb--left" />
      <div className="mv-orb mv-orb--right" />

      {/* Section label */}
      <div className={`mv-eyebrow ${visible ? 'mv-animate--fade-up' : ''}`}>
        <span className="mv-eyebrow__line" />
        <span className="mv-eyebrow__text">WHO WE ARE</span>
        <span className="mv-eyebrow__line" />
      </div>

      <h2 className={`mv-heading ${visible ? 'mv-animate--fade-up mv-delay-1' : ''}`}>
        Purpose &amp; Direction
      </h2>

      <div className="mv-cards">
        {/* Mission Card */}
        <div className={`mv-card mv-card--mission ${visible ? 'mv-animate--slide-left mv-delay-2' : ''}`}>
          <div className="mv-card__icon-wrap">
            <svg className="mv-card__icon" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="20" stroke="#a26200" strokeWidth="2" strokeDasharray="4 3" />
              <circle cx="24" cy="24" r="12" stroke="#a26200" strokeWidth="2" />
              <circle cx="24" cy="24" r="4" fill="#a26200" />
              <line x1="24" y1="4" x2="24" y2="12" stroke="#a26200" strokeWidth="2" strokeLinecap="round" />
              <line x1="24" y1="36" x2="24" y2="44" stroke="#a26200" strokeWidth="2" strokeLinecap="round" />
              <line x1="4" y1="24" x2="12" y2="24" stroke="#a26200" strokeWidth="2" strokeLinecap="round" />
              <line x1="36" y1="24" x2="44" y2="24" stroke="#a26200" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <div className="mv-card__icon-ring" />
          </div>

          <span className="mv-card__label">Our Mission</span>
          <h3 className="mv-card__title">Delivering Justice With Precision</h3>
          <p className="mv-card__text">
            We are committed to providing every client with unwavering legal representation rooted in integrity and expertise. Our mission is to protect your rights, navigate complex legal landscapes, and secure the outcomes you deserve — with clarity and conviction at every step.
          </p>

          <ul className="mv-card__pillars">
            <li><span className="mv-pillar-dot" />Integrity First</li>
            <li><span className="mv-pillar-dot" />Client-Centered Approach</li>
            <li><span className="mv-pillar-dot" />Proven Excellence</li>
          </ul>

          <div className="mv-card__accent-line" />
        </div>

        {/* Divider */}
        <div className={`mv-divider ${visible ? 'mv-animate--fade-up mv-delay-3' : ''}`}>
          <div className="mv-divider__bar" />
          <div className="mv-divider__diamond">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L22 12L12 22L2 12Z" fill="#a26200" />
            </svg>
          </div>
          <div className="mv-divider__bar" />
        </div>

        {/* Vision Card */}
        <div className={`mv-card mv-card--vision ${visible ? 'mv-animate--slide-right mv-delay-2' : ''}`}>
          <div className="mv-card__icon-wrap">
            <svg className="mv-card__icon" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 24C4 24 10 10 24 10C38 10 44 24 44 24C44 24 38 38 24 38C10 38 4 24 4 24Z" stroke="#a26200" strokeWidth="2" />
              <circle cx="24" cy="24" r="7" stroke="#a26200" strokeWidth="2" />
              <circle cx="24" cy="24" r="3" fill="#a26200" />
              <path d="M24 10V6M24 42V38M44 24H40M8 24H4" stroke="#a26200" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
            <div className="mv-card__icon-ring" />
          </div>

          <span className="mv-card__label">Our Vision</span>
          <h3 className="mv-card__title">Redefining Legal Standards</h3>
          <p className="mv-card__text">
            We envision a future where every individual has access to fearless, world-class legal advocacy. By blending deep legal knowledge with forward-thinking strategy, we strive to set new benchmarks in the legal industry — building a legacy of trust, justice, and transformative impact.
          </p>

          <ul className="mv-card__pillars">
            <li><span className="mv-pillar-dot" />Accessible Justice</li>
            <li><span className="mv-pillar-dot" />Industry Leadership</li>
            <li><span className="mv-pillar-dot" />Lasting Legacy</li>
          </ul>

          <div className="mv-card__accent-line" />
        </div>
      </div>


     
    </section>
  );
};

export default MissionVision;